// extracted by mini-css-extract-plugin
export default {"buttonSection":"ViewApplication_buttonSection__ExCHR","publishButton":"ViewApplication_publishButton__1n5gF","closeButton":"ViewApplication_closeButton__7N5y0"};